module.exports = __webpack_public_path__ + "static/careandwear.305896ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/careandwear.png
// module id = 433
// module chunks = 246384609461072